/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { h } from 'preact';
import { useState } from 'preact/hooks';
import classnames from 'classnames';

import { IconTickNo, IconTickYes, IconCaretDown } from '../../components/icons';

export const TableRow = ({ title, full, basic }) => (
    <div className="c-compare-plans__row">
        <span className="c-compare-plans__title">{title}</span>
        <span className="c-compare-plans__icon">
            {basic ? <IconTickYes size="20" /> : <IconTickNo size="20" />}
        </span>
        <span className="c-compare-plans__icon">
            {full ? <IconTickYes size="20" /> : <IconTickNo size="20" />}
        </span>
    </div>
);

export const ExpandableTableRow = ({
    full,
    basic,
    children,
    className,
    expanded = false,
    title,
}) => {
    const [isExpanded, setExpanded] = useState(expanded);
    return (
        <div
            className={classnames('c-compare-plans__row u-no-outline', className)}
            onClick={() => setExpanded(!isExpanded)}
            onKeyDown={(e) => (e.which === 13 || e.which === 32) && setExpanded(!isExpanded)}
            tabIndex={0}
        >
            <span className="c-compare-plans__title">
                <div className="c-link c-link-element u-flex u-items-center u-pointer">
                    <span>{title}</span>
                    <IconCaretDown
                        className={classnames('u-font-5 u-flex-none', {
                            'is-expanded': isExpanded,
                        })}
                    />
                </div>
                <div
                    className={classnames('c-compare-plans__details', {
                        'is-expanded': isExpanded,
                    })}
                >
                    <div className="u-font-2">{children}</div>
                </div>
            </span>
            <span className="c-compare-plans__icon">
                {basic ? <IconTickYes size="20" /> : <IconTickNo size="20" />}
            </span>
            <span className="c-compare-plans__icon">
                {full ? <IconTickYes size="20" /> : <IconTickNo size="20" />}
            </span>
        </div>
    );
};
